/* Legacy finance dialog controls. No payment or cart behaviour is changed. */
(() => {
  function initialise() {
    const overlay = document.getElementById('finance-popup-overlay');
    const panel = document.getElementById('finance-popup');
    const close = document.getElementById('finance-popup-close');
    const triggers = document.querySelectorAll('.btn-finance-popup');
    if (!overlay || !panel || !close || !triggers.length || overlay.dataset.financeReviewBound) return;
    overlay.dataset.financeReviewBound = 'true';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-labelledby', 'uk-finance-review-title');
    overlay.setAttribute('aria-hidden', 'true');
    let opener = null;
    let previousOverflow = '';
    let previousHeight = '';
    const isOpen = () => overlay.dataset.active === 'true';
    const hide = () => {
      if (!isOpen()) return;
      overlay.dataset.active = 'false';
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = previousOverflow;
      document.body.style.height = previousHeight;
      if (opener) {
        opener.setAttribute('aria-expanded', 'false');
        opener.focus({ preventScroll: true });
      }
    };
    triggers.forEach(trigger => {
      trigger.setAttribute('aria-controls', 'finance-popup');
      trigger.setAttribute('aria-expanded', 'false');
      trigger.addEventListener('click', event => {
        event.preventDefault();
        if (isOpen()) return;
        opener = trigger;
        previousOverflow = document.body.style.overflow;
        previousHeight = document.body.style.height;
        overlay.dataset.active = 'true';
        overlay.setAttribute('aria-hidden', 'false');
        trigger.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
        window.requestAnimationFrame(() => {
          if (isOpen()) close.focus({ preventScroll: true });
        });
        // The inherited Tailwind visibility transition can defer focusability.
        window.setTimeout(() => {
          if (isOpen() && !panel.contains(document.activeElement)) close.focus({ preventScroll: true });
        }, 320);
      });
    });
    close.addEventListener('click', hide);
    overlay.addEventListener('click', event => { if (event.target === overlay) hide(); });
    document.addEventListener('keydown', event => {
      if (!isOpen()) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        hide();
      } else if (event.key === 'Tab') {
        const focusable = [...panel.querySelectorAll('button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])')]
          .filter(element => !element.disabled && element.getClientRects().length);
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (first && !panel.contains(document.activeElement)) {
          event.preventDefault(); (event.shiftKey ? last : first).focus();
        } else if (first && event.shiftKey && document.activeElement === first) {
          event.preventDefault(); last.focus();
        } else if (last && !event.shiftKey && document.activeElement === last) {
          event.preventDefault(); first.focus();
        }
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true });
  else initialise();
})();
